export default function Testimonials() {
  const testimonials = [
    {
      name: 'Steve Allouche',
      location: 'Local Guide · 130 reviews · 146 photos',
      rating: 5,
      text: 'Had an old house that needed rewiring, and Urban Connect exceeded expectations by far. They took no shortcuts, replacing all the lights, power points, light switches, and circuit breakers. This was the only company on-site that did the job thoroughly without cutting corners. Could not recommend them more.',
      date: 'A year ago',
      initial: 'S'
    },
    {
      name: 'Sam Srinivasan',
      location: 'Local Guide · 674 reviews · 7,658 photos',
      rating: 5,
      text: 'Used these guys to connect up our NBN cable to the house and it was quick, done properly and everything worked well. John was quick to come around and did a quote and agreed to do it straightaway. He was detailed and treated our property with respect and replaced everything including the cable ducts and everything looked neat and tidy when he was finished. Got our NBN working promptly and was a very friendly and efficient technician. Happy to use his services again.',
      date: '3 years ago',
      initial: 'S'
    },
    {
      name: 'Edward',
      location: 'Local Guide · 60 reviews · 29 photos',
      rating: 5,
      text: "I've used John for two properties. One was a new build and the other a renovation. He has always come through and done a top quality job. John and his boys are punctual, do a great job, and are very fairly priced. Thank you.",
      date: '3 years ago',
      initial: 'E'
    },
    {
      name: 'Michael Ilievski',
      location: '4 reviews',
      rating: 5,
      text: 'John is very professional and always available to provide advice when needed. The team is hard working and the pricing is extremely competitive. They also saved us when we had an emergency issue on short notice. Highly recommended and will only ever use Urban Connect from now on for all my electrical and data needs.',
      date: '3 years ago',
      initial: 'M'
    },
    {
      name: 'Raditya UK',
      location: '1 review',
      rating: 5,
      text: "John and his team handled all the electrical work in the major renovation of my house in the Sydney lower north shore. The electrical work was quite complex as I had engaged consultants to develop plans for lighting design and security. John always showed a \"can do\" attitude and took the time to come up with solutions whenever problems arose. And he's been a pleasure to work with - he always has a smile on his face :-) Highly recommended.",
      date: '3 years ago',
      initial: 'R'
    },
    {
      name: 'Psy H',
      location: 'Local Guide · 295 reviews · 1,166 photos',
      rating: 5,
      text: "Refreshingly professional, knowledgeable and respectful. True expertise and real value for money - they define what good customer service and experience should look like in this industry. The quality in Urban Connect's work is second to none. With a true people leader at the helm of this company, it's precisely the reason I continue to appoint these guys on projects and will never look anywhere else for electrical services in Sydney and the surrounds. The Urban Connect team are the only team to partner with when you need a job done properly. Thanks John and the crew.",
      date: '3 years ago',
      initial: 'P'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            What Our Customers Say
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-5 md:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center mb-3 md:mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-base md:text-lg"></i>
                ))}
              </div>
              <p className="text-sm md:text-base text-gray-700 mb-4 md:mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white font-bold text-base md:text-lg mr-3 md:mr-4">
                  {testimonial.initial}
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm md:text-base">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs md:text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}